// PWA-wide date formatting — the React face of dateFormatCore.js. Every
// formatter (formatDate, formatIfCanonicalDate, the presets, setDateFormat)
// lives in the core, which has no React import so the node suite can prove
// it; this module re-exports it and adds the hook.

import { useEffect, useState } from 'react';
import { getDateFormatVersion, subscribeDateFormat } from './dateFormatCore.js';

export * from './dateFormatCore.js';

// Hook — components that render dates can call this to force a
// re-render whenever the admin changes the global format. Returns an
// integer that bumps on every change.
export function useDateFormatVersion() {
  const [v, setV] = useState(getDateFormatVersion());
  useEffect(() => subscribeDateFormat(() => setV(getDateFormatVersion())), []);
  return v;
}
